<template>
    <div class="choices-container fade">
        <div
            v-if="question.type == 'checkbox'"
            :class="{ 'checkboxes-container': question.type == 'checkbox' }">
            <InputCheckbox
                v-for="option in question.options"
                :key="option.title"
                :option="option"
                :name="question.key"
                v-model="values"
                :inputValue="option.title"
                :max="question.maxSelection"
                @setTouched="setTouched"
            />
        </div>
        <div v-else>
            <InputRadio
                v-for="option in question.options"
                :key="option.name"
                :option="option"
                :name="question.key"
                v-model="value"
                @setTouched="setTouched"
            />
        </div>
    </div>
</template>

<script>
import InputRadio from './InputRadio.vue'
import InputCheckbox from './InputCheckbox.vue'
import { mapState } from 'vuex';

export default {
    name: 'Choices',
    props: ['question'],
    components: {
        InputRadio,
        InputCheckbox,
    },
    mounted() {
        // console.log(this.question);
        const savedResult = this.results.find(result => result.key == this.question.key);
        if ( savedResult ) {
            console.log({savedResult});
            // load result and set its value for the form
            this.$nextTick(() => {
                if (savedResult.type == "checkbox") {
                    this.values = this.question.options.filter(
                        (option) => savedResult.selection.includes(option.title)
                    ).map( option => option.title );
                } else {

                    this.value = this.question.options.find( option => option.value == savedResult.selection ).value;
                }
            })
        }
    },
    data() {
        return {
            value: null,
            values: []
        }
    },
    watch: {
        '$store.state.results': function() {
            console.log(this.$store.state.results)
            if( this.$store.state.results.length == 0) {
                this.value = null;
                this.values = [];
            }
        }
    },
    methods: {
        setTouched() {
            console.log('touched');
            this.$emit('setTouched', {
                type: this.question.type,
                value: this.question.type == 'checkbox' ? this.values : this.value
            });
        }
    },
    computed: {
        ...mapState({
            results: state => state.results,
        })
    }
}
</script>

<style scoped>

.choices-container {
    margin: 0 auto;
}

@media (min-width: 900px) {
    .choices-container {
        margin: 0 auto 2rem;
    }
}

.checkboxes-container {
    display: grid;
    gap: 12px;
}

@media (min-width: 900px) {
    .checkboxes-container {
        grid-template-columns: 1fr 1fr;
    }
}

@keyframes fade {
    from {
        opacity: 0.5;
        transform: translateX(100px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
.fade {
    animation: fade 0.5s ease-out;
}
</style>
